export const GET_EVENTS = "GET_EVENTS"
export const GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS"
export const GET_EVENTS_FAILED = "GET_EVENTS_FAILED"
export const RESET_EVENTS = "RESET_EVENTS"

export const SHOW_LOADING_INDICATOR = "SHOW_LOADING_INDICATOR"
export const HIDE_LOADING_INDICATOR = "HIDE_LOADING_INDICATOR"

export const CHANGE_EVENT_PUBLISH_FIELD = "CHANGE_EVENT_PUBLISH_FIELD"
export const CHANGE_EVENT_PUBLISH_FIELD_SUCCESS =
  "CHANGE_EVENT_PUBLISH_FIELD_SUCCESS"
export const CHANGE_EVENT_PUBLISH_FIELD_FAILED =
  "CHANGE_EVENT_PUBLISH_FIELD_FAILED"

export const SELECT_SINGLE_EVENT = "SELECT_SINGLE_EVENT"
export const SELECT_ALL_EVENTS = "SELECT_ALL_EVENTS"
export const RESET_EVENTS_SELECTION = "RESET_EVENTS_SELECTION"
export const SET_EVENTS_SORT_OPTIONS = "SET_EVENTS_SORT_OPTIONS"

export const UPDATE_CATEGORIZED_EVENT_ORDER = "UPDATE_CATEGORIZED_EVENT_ORDER"
export const UPDATE_CATEGORIZED_EVENT_ORDER_SUCCESS =
  "UPDATE_CATEGORIZED_EVENT_ORDER_SUCCESS"
export const UPDATE_CATEGORIZED_EVENT_ORDER_FAILED =
  "UPDATE_CATEGORIZED_EVENT_ORDER_FAILED"

export const UPDATE_EVENT_ORDER = "UPDATE_EVENT_ORDER"
export const UPDATE_EVENT_ORDER_FAILED = "UPDATE_EVENT_ORDER_FAILED"
export const UPDATE_EVENT_ORDER_SUCCESS = "UPDATE_EVENT_ORDER_SUCCESS"

export const CHANGE_EVENT_DRAGGABLE_PROPERTY = "CHANGE_EVENT_DRAGGABLE_PROPERTY"

export const UPDATE_BULK_PUBLISH_STATUS = "UPDATE_BULK_PUBLISH_STATUS"
export const UPDATE_BULK_PUBLISH_STATUS_SUCCESS =
  "UPDATE_BULK_PUBLISH_STATUS_SUCCESS"
export const UPDATE_BULK_PUBLISH_STATUS_FAILED =
  "UPDATE_BULK_PUBLISH_STATUS_FAILED"

export const OPEN_PUBLISH_NOTIFICATION_MODAL = "OPEN_PUBLISH_NOTIFICATION_MODAL"
export const HIDE_PUBLISH_NOTIFICATION_MODAL = "HIDE_PUBLISH_NOTIFICATION_MODAL"

export const OPEN_DELETE_EVENT_MODAL = "OPEN_DELETE_EVENT_MODAL"
export const HIDE_DELETE_EVENT_MODAL = "HIDE_DELETE_EVENT_MODAL"
export const HANDLE_DELETE_EVENT = "HANDLE_DELETE_EVENT"
export const HANDLE_DELETE_EVENT_SUCCESS = "HANDLE_DELETE_EVENT_SUCCESS"
export const HANDLE_DELETE_EVENT_FAILED = "HANDLE_DELETE_EVENT_FAILED"

export const OPEN_EVENT_BULK_DELETE_MODAL = "OPEN_EVENT_BULK_DELETE_MODAL"
export const HIDE_EVENT_BULK_DELETE_MODAL = "HIDE_EVENT_BULK_DELETE_MODAL"
export const HANDLE_EVENT_BULK_DELETE = "HANDLE_EVENT_BULK_DELETE"
export const HANDLE_EVENT_BULK_DELETE_SUCCESS =
  "HANDLE_EVENT_BULK_DELETE_SUCCES"
export const HANDLE_EVENT_BULK_DELETE_FAILED = "HANDLE_EVENT_BULK_DELETE_FAILED"

export const ADD_NEW_EXPERIENCE = "ADD_NEW_EXPERIENCE"
export const ADD_NEW_EXPERIENCE_SUCCESS = "ADD_NEW_EXPERIENCE_SUCCESS"
export const ADD_NEW_EXPERIENCE_FAILED = "ADD_NEW_EXPERIENCE_FAILED"

export const GET_SELECTED_EVENT = "GET_SELECTED_EVENT"
export const GET_SELECTED_EVENT_SUCCESS = "GET_SELECTED_EVENT_SUCCESS"
export const GET_SELECTED_EVENT_FAILED = "GET_SELECTED_EVENT_FAILED"
export const RESET_SELECTED_EVENT = "RESET_SELECTED_EVENT"

export const SEND_INVITES = "SEND_INVITES"
export const SEND_INVITES_SUCCESS = "SEND_INVITES_SUCCESS"
export const SEND_INVITES_FAILED = "SEND_INVITES_FAILED"

export const GET_EVENT_INVITE_LIST = "GET_EVENT_INVITE_LIST"
export const GET_EVENT_INVITE_LIST_SUCCESS = "GET_EVENT_INVITE_LIST_SUCCESS"
export const GET_EVENT_INVITE_LIST_FAILED = "GET_EVENT_INVITE_LIST_FAILED"
export const RESET_EVENT_INVITE_LIST = "RESET_EVENT_INVITE_LIST"

export const DELETE_INVITE = "DELETE_INVITE"
export const DELETE_INVITE_SUCCESS = "DELETE_INVITE_SUCCESS"
export const DELETE_INVITE_FAILED = "DELETE_INVITE_FAILED"

export const ADD_ACCESS_CODE = "ADD_ACCESS_CODE"
export const ADD_ACCESS_CODE_SUCCESS = "ADD_ACCESS_CODE_SUCCESS"
export const ADD_ACCESS_CODE_FAILED = "ADD_ACCESS_CODE_FAILED"
export const POST_IMAGE_ACCESS_CODE = "POST_IMAGE_ACCESS_CODE"

export const ADD_ACCESS_TAG = "ADD_ACCESS_TAG"
export const ADD_ACCESS_TAG_SUCCESS = "ADD_ACCESS_TAG_SUCCESS"
export const ADD_ACCESS_TAG_FAILED = "ADD_ACCESS_TAG_FAILED"

export const OPEN_SAVING_MODAL = "OPEN_SAVING_MODAL"
export const HIDE_SAVING_MODAL = "HIDE_SAVING_MODAL"

export const SET_EVENT_INVITE_LIST_SORT_OPTIONS =
  "SET_EVENT_INVITE_LIST_SORT_OPTIONS"

export const EDIT_ATTENDEE = "EDIT_ATTENDEE"
export const EDIT_ATTENDEE_SUCCESS = "EDIT_ATTENDEE_SUCCESS"
export const EDIT_ATTENDEE_FAILED = "EDIT_ATTENDEE_FAILED"

export const EDIT_ATTENDEE_AND_RSVP = "EDIT_ATTENDEE_AND_RSVP"
export const EDIT_ATTENDEE_AND_RSVP_SUCCESS = "EDIT_ATTENDEE_AND_RSVP_SUCCESS"
export const EDIT_ATTENDEE_AND_RSVP_FAILED = "EDIT_ATTENDEE_AND_RSVP_FAILED"

export const UPDATE_RSVP = "UPDATE_RSVP"
export const UPDATE_RSVP_SUCCESS = "UPDATE_RSVP_SUCCESS"
export const UPDATE_RSVP_FAILED = "UPDATE_RSVP_FAILED"

export const SEND_APP_INVITES = "SEND_APP_INVITES"
export const SEND_APP_INVITES_SUCCESS = "SEND_APP_INVITES_SUCCESS"
export const SEND_APP_INVITES_FAILED = "SEND_APP_INVITES_FAILED"

export const OPEN_INACTIVE_EVENT_WARNING_MODAL =
  "OPEN_INACTIVE_EVENT_WARNING_MODAL"
export const HIDE_INACTIVE_EVENT_WARNING_MODAL =
  "HIDE_INACTIVE_EVENT_WARNING_MODAL"

export const DELETE_RSVP = "DELETE_RSVP"
export const DELETE_RSVP_SUCCESS = "DELETE_RSVP_SUCCESS"
export const DELETE_RSVP_FAILED = "DELETE_RSVP_FAILED"

export const UPDATE_EVENT_ACCESS_TYPE = "UPDATE_EVENT_ACCESS_TYPE"
export const UPDATE_EVENT_ACCESS_TYPE_SUCCESS =
  "UPDATE_EVENT_ACCESS_TYPE_SUCCESS"
export const UPDATE_EVENT_ACCESS_TYPE_FAILED = "UPDATE_EVENT_ACCESS_TYPE_FAILED"

export const GET_EVENT_MENU_LIST = "GET_EVENT_MENU_LIST"
export const GET_EVENT_MENU_LIST_SUCCESS = "GET_EVENT_MENU_LIST_SUCCESS"
export const GET_EVENT_MENU_LIST_FAILED = "GET_EVENT_MENU_LIST_FAILED"

export const UPDATE_EVENT_MENU_FEATURES_ORDER =
  "UPDATE_EVENT_MENU_FEATURES_ORDER"
export const UPDATE_EVENT_MENU_FEATURES_ORDER_SUCCESS =
  "UPDATE_EVENT_MENU_FEATURES_ORDER_SUCCESS"
export const UPDATE_EVENT_MENU_FEATURES_ORDER_FAILED =
  "UPDATE_EVENT_MENU_FEATURES_ORDER_FAILED"

export const UPDATE_EXPERIENCE = "UPDATE_EXPERIENCE"
export const UPDATE_EXPERIENCE_SUCCESS = "UPDATE_EXPERIENCE_SUCCESS"
export const UPDATE_EXPERIENCE_FAILED = "UPDATE_EXPERIENCE_FAILED"

export const GET_EVENT_ACCESS_CODES = "GET_EVENT_ACCESS_CODES"
export const GET_EVENT_ACCESS_CODES_SUCCESS = "GET_EVENT_ACCESS_CODES_SUCCESS"
export const GET_EVENT_ACCESS_CODES_FAILED = "GET_EVENT_ACCESS_CODES_FAILED"

export const GET_INITIAL_ACCESS_TAGS = "GET_INITIAL_ACCESS_TAGS"
export const GET_INITIAL_ACCESS_TAGS_SUCCESS = "GET_INITIAL_ACCESS_TAGS_SUCCESS"
export const GET_INITIAL_ACCESS_TAGS_FAILED = "GET_INITIAL_ACCESS_TAGS_FAILED"

export const JOIN_EVENT = "JOIN_EVENT"
export const JOIN_EVENT_SUCCESS = "JOIN_EVENT_SUCCESS"
export const JOIN_EVENT_FAILED = "JOIN_EVENT_FAILED"

export const ASSIGN_EVENT_TO_CATEGORY = "ASSIGN_EVENT_TO_CATEGORY"
export const GET_EVENT_CATEGORIES = "GET_EVENT_CATEGORIES"
export const GET_EVENT_CATEGORIES_SUCCESS = "GET_EVENT_CATEGORIES_SUCCESS"
export const GET_EVENT_CATEGORIES_FAILED = "GET_EVENT_CATEGORIES_FAILED"

export const GET_EVENT_CODES = "GET_EVENT_CODES"
export const GET_EVENT_CODES_SUCCESS = "GET_EVENT_CODES_SUCCESS"
export const GET_EVENT_CODES_FAILED = "GET_EVENT_CODES_FAILED"

export const OPEN_EXPERIENCES_ERROR_MODAL = "OPEN_EXPERIENCES_ERROR_MODAL"
export const HIDE_EXPERIENCES_ERROR_MODAL = "HIDE_EXPERIENCES_ERROR_MODAL"

export const SEND_EMAIL_INVITE = "SEND_EMAIL_INVITE"
export const SEND_EMAIL_INVITE_SUCCESS = "SEND_EMAIL_INVITE_SUCCESS"
export const SEND_EMAIL_INVITE_FAILED = "SEND_EMAIL_INVITE_FAILED"

export const GET_EVENT_DEEPLINK_URL = "GET_EVENT_DEEPLINK_URL"
export const GET_EVENT_DEEPLINK_URL_SUCCESS = "GET_EVENT_DEEPLINK_URL_SUCCESS"
export const GET_EVENT_DEEPLINK_URL_FAILED = "GET_EVENT_DEEPLINK_URL_FAILED"

export const GET_EVENT_DEEPLINK_CODES = "GET_EVENT_DEEPLINK_CODES"
export const GET_EVENT_DEEPLINK_CODES_SUCCESS =
  "GET_EVENT_DEEPLINK_CODES_SUCCESS"
export const GET_EVENT_DEEPLINK_CODES_FAILED = "GET_EVENT_DEEPLINK_CODES_FAILED"

export const GENERATE_DEEPLINK_CODES = "GENERATE_DEEPLINK_CODES"
export const GENERATE_DEEPLINK_CODES_SUCCESS = "GENERATE_DEEPLINK_CODES_SUCCESS"
export const GENERATE_DEEPLINK_CODES_FAILED = "GENERATE_DEEPLINK_CODES_FAILED"

export const OPEN_GENERATE_DEEPLINK_MODAL = "OPEN_GENERATE_DEEPLINK_MODAL"
export const HIDE_GENERATE_DEEPLINK_MODAL = "HIDE_GENERATE_DEEPLINK_MODAL"

export const OPEN_EXP_CLONE_CONFIRMATION_MODAL =
  "OPEN_EXP_CLONE_CONFIRMATION_MODAL"
export const HIDE_EXP_CLONE_CONFIRMATION_MODAL =
  "HIDE_EXP_CLONE_CONFIRMATION_MODAL"

export const CLONE_EXPERIENCE = "CLONE_EXPERIENCE"
export const CLONE_EXPERIENCE_SUCCESS = "CLONE_EXPERIENCE_SUCCESS"
export const CLONE_EXPERIENCE_FAILED = "CLONE_EXPERIENCE_FAILED"
